// Generated by ReScript, PLEASE EDIT WITH CARE

import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";

var Raw = {};

var query = GraphqlTag.gql(["query FindCurrentMd5Query($name: String!)  {\nacademyCurrentMd5(name: $name)  \n}\n"]);

function parse(value) {
  return {
          academyCurrentMd5: value.academyCurrentMd5
        };
}

function serialize(value) {
  var value$1 = value.academyCurrentMd5;
  return {
          academyCurrentMd5: value$1
        };
}

function serializeVariables(inp) {
  return {
          name: inp.name
        };
}

function makeVariables(name, param) {
  return {
          name: name
        };
}

var FindCurrentMd5Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var FindCurrentMd5Query = {
  FindCurrentMd5Query_inner: FindCurrentMd5Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useFetch: useFetch
};

var CurrentMd5 = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

function use$1(name) {
  var $$fetch = CurrentMd5.useAsync();
  return async function () {
    return await $$fetch({
                name: name
              });
  };
}

export {
  FindCurrentMd5Query ,
  CurrentMd5 ,
  use$1 as use,
}
/* query Not a pure module */
